import { useApi } from "../../../swr/useApi";
import { productWarrantiesService } from "../../api_client";
import type { ProductWarrantyDto } from "../../../api";

export function useProductWarranties() {
    return useApi<ProductWarrantyDto[]>("product-warranties", async () => {
        return await productWarrantiesService.getProductWarranties();
    });
}


